import type { groups_GroupResponse } from "@/api";

/**
 * Filter groups for a given childcare selection.
 *
 * Groups with no childcare_id are org-wide and available for every childcare.
 * Groups with a matching childcare_id are childcare-specific and available
 * only for that childcare. Passing null/empty returns all groups unchanged.
 *
 * This mirrors the backend query `ListGroupsByOrgAndChildcare`
 * (`childcare_id IS NULL OR childcare_id = $2`).
 */
export function filterGroupsForChildcare<T extends Pick<groups_GroupResponse, "childcare_id">>(
  groups: readonly T[],
  childcareId: string | null | undefined
): T[] {
  if (!childcareId) return [...groups];
  return groups.filter((g) => !g.childcare_id || g.childcare_id === childcareId);
}
